import { useEffect, useState, useRef } from "react";
import "./App.css";
import payment_methods from "../src/images/payment-method.svg";
// import { loadStripe } from "@stripe/stripe-js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from "react-hot-toast";
import SocialMedia from "./components/SocialMedia";
import swal from "sweetalert2";

// let stripePromise;

// const getStripe = () => {
//   if (!stripePromise) {
//     stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
//   }

//   return stripePromise;
// };

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function App() {
  useEffect(() => {
    getNextSatarday(new Date());
    getDefaultTime();
    paymentStatus();
    OfferAlert();
  }, []);

  function OfferAlert() {
    setTimeout(() => {
      swal.fire({
        title: "50% Flat Off",
        html: "Apply the code <b>OFFER50</b> to avail a straight 50% discount.",
        imageUrl:
          "https://raw.githubusercontent.com/AlanBinu007/Alan_Binu_Resume_CV/main/57882.jpg",
        imageWidth: 250,
        imageHeight: 250,
        imageAlt: "50% Off",
        showConfirmButton: false,
        timer: 90000,
      });
    }, 3000);
  }

  const formData = useRef();

  function fileDownload() {
    const apiPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ data: "okay" });
      }, 2000);
    });
    toast.promise(apiPromise, {
      loading: "Getting the file.....",
      success: "Downloading the file.....",
    });
  }

  function sendSucessPaymentEmail() {
    var name = localStorage.getItem("UserName");
    var email = localStorage.getItem("UserEmail");
    const templateParams = {
      name: name,
      email: email,
    };

    emailjs
      .send(
        "service_4s7nptb",
        "template_0nn6dva",
        templateParams,
        "user_gfDwVVfxclGN8gJp0Uiak"
      )
      .then(
        (response) => {
          toast.success("Email Send Sucessfully!");
        },
        (err) => {
          toast.error("Error sending email");
        }
      );
    localStorage.clear();
  }

  // function sendFailurePaymentEmail() {
  //   var name = localStorage.getItem("UserName");
  //   var email = localStorage.getItem("UserEmail");
  //   const templateParams = {
  //     name: name,
  //     email: email,
  //   };

  //   emailjs
  //     .send(
  //       "service_4s7nptb",
  //       "template_tjafvue",
  //       templateParams,
  //       "user_gfDwVVfxclGN8gJp0Uiak"
  //     )
  //     .then(
  //       (response) => {
  //         toast.success("Email Send Sucessfully!");
  //       },
  //       (err) => {
  //         toast.error("Error sending email");
  //       }
  //     );
  //   localStorage.clear();
  // }

  function saveName(event) {
    localStorage.setItem("UserName", event.target.value);
  }

  function saveEmail(event) {
    localStorage.setItem("UserEmail", event.target.value);
  }

  function paymentStatus() {
    let name = localStorage.getItem("UserName");
    if (
      window.location.pathname == "/success" &&
      localStorage.getItem("PaymentPageRedirect")
    ) {
      toast.success(
        "Hello, " +
          JSON.stringify(name) +
          ". Your payment has been verified. I will be in touch with you shortly. Thank you."
      );
      sendSucessPaymentEmail();
      window.history.pushState({}, "", "/");
    }
    // else if (
    //   window.location.pathname == "/cancel" &&
    //   localStorage.getItem("PaymentPageRedirect")
    // ) {
    //   toast.error(
    //     "Hey, " + JSON.stringify(name) + " Your payment has been Cancelled!"
    //   );
    //   sendFailurePaymentEmail();
    //   window.history.pushState({}, "", "/");
    // }
  }

  const [selectedDate, setSelectedDate] = useState(new Date());
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [selectedTime, setSelectedTime] = useState(new Date());
  const handleTimeChange = (date) => {
    setSelectedTime(date);
  };

  const [selectedAltTime, setSelectedAltTime] = useState(new Date());
  const handleAltTimeChange = (date) => {
    setSelectedAltTime(date);
  };

  const [selectedAltDate, setSelectedAltDate] = useState(new Date());
  const handleAltDateChange = (date) => {
    setSelectedAltDate(date);
  };

  function getDefaultTime() {
    let newTime = new Date();
    newTime.setHours(8);
    newTime.setMinutes(0);
    newTime.setSeconds(0);
    newTime.setMilliseconds(0);

    setSelectedAltTime(newTime);
    setSelectedTime(newTime);
  }

  function getNextSatarday(date = new Date()) {
    const dateCopy = new Date(date.getTime());

    const nextSatarday = new Date(
      dateCopy.setDate(
        dateCopy.getDate() + ((7 - dateCopy.getDay() - 1) % 7 || 7)
      )
    );

    const nextAltSatarday = new Date(
      dateCopy.setDate(dateCopy.getDate() + (7 - dateCopy.getDay()))
    );
    setSelectedDate(nextSatarday);
    setSelectedAltDate(nextAltSatarday);
  }

  const [isEnable, setEnable] = useState(true);
  const [isLoading, setLoading] = useState(false);

  // const [stripeError, setStripeError] = useState(null);
  // const item = {
  //   price: "price_1NdZ8iSFe191vsn9xcWfJwt8",
  //   quantity: 1,
  // };

  // const checkoutOptions = {
  //   lineItems: [item],
  //   mode: "payment",
  //   successUrl: `${window.location.origin}/success`,
  //   cancelUrl: `${window.location.origin}/cancel`,
  // };

  // const redirectToCheckout = async () => {
  //   const apiPromise = new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       resolve({ data: "okay" });
  //     }, 1000);
  //   });
  //   toast.promise(apiPromise, {
  //     loading: "Redirecting to stripe...",
  //     success: <b>Going to Stripe checkout..</b>,
  //     error: <b>Failed to load stripe.</b>,
  //   });
  //   await delay(1000);
  //   setLoading(true);
  //   localStorage.setItem("PaymentPageRedirect", true);
  //   const stripe = await getStripe();
  //   const { error } = await stripe.redirectToCheckout(checkoutOptions);
  //   setLoading(false);
  //   if (error) setStripeError(error.message);
  // };

  const redirectToCheckout = async () => {
    const apiPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ data: "okay" });
      }, 1000);
    });
    toast.promise(apiPromise, {
      loading: "Redirecting to stripe...",
      success: <b>Going to Stripe checkout..</b>,
      error: <b>Failed to load stripe.</b>,
    });
    await delay(1000);
    setLoading(true);
    window.location.href = "https://book.stripe.com/6oE9CvdjkbXvaTS003";
    localStorage.setItem("PaymentPageRedirect", true);
    setLoading(false);
  };

  // if (stripeError) toast.error("Something went wrong in Stripe!");

  async function enablePayButton(e) {
    e.preventDefault();
    const apiPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ data: "okay" });
      }, 2000);
    });
    toast.promise(apiPromise, {
      loading: "Saving...",
      success: <b>Data saved successfully!</b>,
      error: <b>Could not save.</b>,
    });
    await delay(2000);
    setEnable(false);
  }

  return (
    <div className="container">
      <Toaster />
      <div className="row">
        <div className="col">
          <div className="w-100"></div>
          <footer id="footer" className="footer">
            <div className="container">
              <br />
              <div className="row">
                <div className="col">
                  <h2 className="h2_className">
                    <b>One to One Consultation Form</b>
                  </h2>
                </div>
                <div className="col">
                  <SocialMedia />
                </div>
              </div>
            </div>
          </footer>
        </div>
        <form ref={formData} class="contact-form" onSubmit={enablePayButton}>
          <div className="row">
            <div className="w-100"></div>
            <div className="col" style={{ marginRight: 40 }}>
              <div className="formbold-mb-5">
                <br />
                <label for="name" className="formbold-form-label">
                  Full Name
                </label>
                <input
                  required
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Full Name"
                  className="formbold-form-input"
                  onChange={saveName}
                />
              </div>
              <div className="flex flex-wrap formbold--mx-3">
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-5 w-full">
                    <label for="date" className="formbold-form-label">
                      {" "}
                      WhatsApp/Phone Number{" "}
                    </label>
                    <input
                      required
                      type="text"
                      name="phone"
                      id="phone"
                      placeholder="Enter your phone number"
                      className="formbold-form-input"
                    />
                  </div>
                </div>
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-5">
                    <label for="time" className="formbold-form-label">
                      {" "}
                      Email{" "}
                    </label>
                    <input
                      required
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter your email"
                      className="formbold-form-input"
                      onChange={saveEmail}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap formbold--mx-3">
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-5 w-full">
                    <label for="date" className="formbold-form-label">
                      {" "}
                      Primary Date{" "}
                    </label>
                    <DatePicker
                      minDate={new Date()}
                      className="formbold-form-input"
                      selected={selectedDate}
                      onChange={handleDateChange}
                      filterDate={(date) => {
                        return (
                          date.getDay() !== 1 &&
                          date.getDay() !== 2 &&
                          date.getDay() !== 3 &&
                          date.getDay() !== 4 &&
                          date.getDay() !== 5
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-5">
                    <label for="time" className="formbold-form-label">
                      {" "}
                      Primary Time{" "}
                    </label>
                    <DatePicker
                      selected={selectedTime}
                      onChange={handleTimeChange}
                      className="formbold-form-input"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={60}
                      timeFormat="HH:mm"
                      dateFormat="hh:mm aa"
                      minTime={setHours(setMinutes(new Date(), 0), 8)}
                      maxTime={setHours(setMinutes(new Date(), 0), 22)}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap formbold--mx-3">
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-5 w-full">
                    <label for="date" className="formbold-form-label">
                      {" "}
                      Alternative Date{" "}
                    </label>
                    <DatePicker
                      minDate={new Date()}
                      className="formbold-form-input"
                      selected={selectedAltDate}
                      onChange={handleAltDateChange}
                      filterDate={(date) => {
                        return (
                          date.getDay() !== 1 &&
                          date.getDay() !== 2 &&
                          date.getDay() !== 3 &&
                          date.getDay() !== 4 &&
                          date.getDay() !== 5
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-5">
                    <label for="time" className="formbold-form-label">
                      {" "}
                      Alternative Time{" "}
                    </label>
                    <DatePicker
                      selected={selectedAltTime}
                      onChange={handleAltTimeChange}
                      className="formbold-form-input"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={60}
                      timeFormat="HH:mm"
                      dateFormat="hh:mm aa"
                      minTime={setHours(setMinutes(new Date(), 0), 8)}
                      maxTime={setHours(setMinutes(new Date(), 0), 22)}
                    />
                  </div>
                </div>
              </div>
              <div className="formbold-input-radio-wrapper">
                <div className="formbold-input-radio-wrapper1">
                  <label for="jobtitle" className="formbold-form-label">
                    {" "}
                    What are you looking for?{" "}
                  </label>
                </div>
                <div className="formbold-radio-flex">
                  <div className="formbold-radio-group">
                    <label className="formbold-radio-label">
                      <input
                        className="formbold-input-radio"
                        type="checkbox"
                        name="jobtitle"
                        id="jobtitle"
                      />
                      Interview Prep
                      <span className="formbold-radio-checkmark"></span>
                    </label>
                  </div>
                  <div className="formbold-radio-group">
                    <label className="formbold-radio-label">
                      <input
                        className="formbold-input-radio"
                        type="checkbox"
                        name="jobtitle"
                        id="jobtitle"
                      />
                      Project Work
                      <span className="formbold-radio-checkmark"></span>
                    </label>
                  </div>
                  <div className="formbold-radio-group">
                    <label className="formbold-radio-label">
                      <input
                        className="formbold-input-radio"
                        type="checkbox"
                        name="jobtitle"
                        id="jobtitle"
                      />
                      Career Development
                      <span className="formbold-radio-checkmark"></span>
                    </label>
                  </div>
                  <div className="formbold-radio-group">
                    <label className="formbold-radio-label">
                      <input
                        className="formbold-input-radio"
                        type="checkbox"
                        name="jobtitle"
                        id="jobtitle"
                        checked
                      />
                      Others
                      <span className="formbold-radio-checkmark"></span>
                    </label>
                  </div>
                  <div className="formbold-radio-group">
                    <br />
                    <br />
                  </div>
                </div>
              </div>
              <div className="formbold-mb-5 w-full">
                <label for="date" className="formbold-form-label">
                  Updated Resume or CV
                </label>
                <input
                  required
                  type="file"
                  name="phone"
                  id="phone"
                  placeholder="Enter your phone number"
                  className="form-control"
                  style={{ paddingBottom: 10, paddingTop: 5 }}
                />
              </div>
            </div>
            <div className="col">
              <div className="formbold-mb-99">
                <label for="date" className="formbold-form-label">
                  <br />
                  Download Study Materials for FREE
                </label>
                <label for="date" className="formbold-form-label">
                  NB: Prior to the scheduled consultation date, it is necessary
                  for all individuals selecting Interview Prep as their service
                  to thoroughly examine the provided document.
                </label>
              </div>
              <div className="flex flex-wrap formbold--mx-3">
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-99 w-full">
                    <a
                      href="https://drive.google.com/u/1/uc?id=1nw4k3ZtORnMTuUx2ynum6d6ZZHYdbu8h&export=downloadhttps://drive.google.com/u/1/uc?id=1nw4k3ZtORnMTuUx2ynum6d6ZZHYdbu8h&export=download"
                      download
                    >
                      <input
                        type="button"
                        className="formbold-btn-download"
                        onClick={fileDownload}
                        value="Core Java"
                      />
                    </a>
                  </div>
                </div>
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-99">
                    <a
                      href="https://drive.google.com/u/1/uc?id=1vfg-HcILkLxx1vOm51CXyBIpNwM-Ws6C&export=download"
                      download
                    >
                      <input
                        type="button"
                        className="formbold-btn-download"
                        value="React Js"
                        onClick={fileDownload}
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap formbold--mx-3">
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-99 w-full">
                    <a
                      href="https://drive.google.com/u/1/uc?id=14AHA7ZwKQ9OgUgZeAmCOoDVKdX814SIN&export=download"
                      download
                    >
                      <input
                        type="button"
                        className="formbold-btn-download"
                        onClick={fileDownload}
                        value=" Spring boot & Microservice"
                      />
                    </a>
                  </div>
                </div>
                <div className="w-full sm:w-half formbold-px-3">
                  <div className="formbold-mb-99">
                    <a
                      href="https://drive.google.com/u/1/uc?id=1h71XLbzMTZ7K_ygPzBNSdMa3DXVvvLA3&export=download"
                      download
                    >
                      <input
                        type="button"
                        className="formbold-btn-download"
                        onClick={fileDownload}
                        value="NoSQl & SQL"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <label for="message" className="formbold-form-label">
                  Any others comments to share
                </label>
                <textarea
                  style={{ height: 130 }}
                  rows="6"
                  name="message"
                  id="message"
                  placeholder="Type here..."
                  className="formbold-form-input"
                ></textarea>
              </div>
              <div>
                <div className="formbold-checkbox-wrapper">
                  <label
                    for="supportCheckbox"
                    className="formbold-checkbox-label"
                  >
                    <div className="formbold-relative">
                      <input
                        type="checkbox"
                        id="supportCheckbox"
                        className="formbold-input-checkbox"
                        required
                      />
                      <span className="formbold-opacity-0">
                        <svg
                          width="11"
                          height="8"
                          viewBox="0 0 11 8"
                          fill="none"
                          className="formbold-stroke-current"
                        >
                          <path
                            d="M10.0915 0.951972L10.0867 0.946075L10.0813 0.940568C9.90076 0.753564 9.61034 0.753146 9.42927 0.939309L4.16201 6.22962L1.58507 3.63469C1.40401 3.44841 1.11351 3.44879 0.932892 3.63584C0.755703 3.81933 0.755703 4.10875 0.932892 4.29224L0.932878 4.29225L0.934851 4.29424L3.58046 6.95832C3.73676 7.11955 3.94983 7.2 4.1473 7.2C4.36196 7.2 4.55963 7.11773 4.71406 6.9584L10.0468 1.60234C10.2436 1.4199 10.2421 1.1339 10.0915 0.951972ZM4.2327 6.30081L4.2317 6.2998C4.23206 6.30015 4.23237 6.30049 4.23269 6.30082L4.2327 6.30081Z"
                            stroke-width="0.4"
                          ></path>
                        </svg>
                      </span>
                    </div>
                    I agree to the defined
                    <a
                      href="https://www.termsfeed.com/live/7505f548-429e-453c-9459-d4977ca09383"
                      target="_blank"
                    >
                      {" "}
                      terms, conditions, and policies
                    </a>
                  </label>
                </div>
                <br />
                <img src={payment_methods} style={{ width: 450 }} />
                <div></div>
                <input
                  type="submit"
                  className="formbold-btn"
                  value="Click Save before Continue"
                />
                <input
                  type="button"
                  className="formbold-btn-save"
                  value="🔒 Pay ₹100"
                  onClick={redirectToCheckout}
                  disabled={isEnable}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="col">
        <footer id="footer" className="footer">
          <div className="container">
            <div className="copyright">
              &copy; Copyright{" "}
              <strong>
                <span>Alan Binu</span>
              </strong>
              . All Rights Reserved
            </div>
            <div className="credits">
              Designed and Managed by{" "}
              <a href="https://alanbinu.com/" target="_blank">
                Alan Binu
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
